import RequestManager from "../../../requests/RequestManager";
import DeleteFavoriteTeamTask from "../../../requests/tasks/sports/deleteFavoriteteamTask";
import logger from 'src/utils/logger/logger';


export const deleteFavoriteTeam = async (teamId, leagueId) => {
    try {
        const deleteFavoriteTeamTask = new DeleteFavoriteTeamTask(teamId, leagueId);
        const response = await RequestManager.addRequest(deleteFavoriteTeamTask);
        return response;
    }catch (error) {
        logger.error('Error deleting favorite team:', error);
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/deleteFavoriteTeam.js